import BaseComponent from 'foundation/base-component';
import React from 'react';
import reactDOM from 'react-dom';
import Cookies from 'js-cookie';
import { bemClasses } from 'general/js/modal';
import { ReactModal } from 'components/modal';
import { redirectTo } from '../../../general/js/utils';

class PromotionModalComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.state = {
            isOpen: false,
        };

        this.render();
        this.initModal();
    }

    isSitecorePreviewMode = () => {
        const params = new URLSearchParams(window.location.search);
        const scMode = params.get('sc_mode');

        return scMode === 'preview' || scMode === 'edit';
    };

    isSitecoreContext = () => (
        !!(this.options && this.options.isInEditingMode) ||
        this.isSitecorePreviewMode()
    );

    initModal = (attempt = 0) => {
        const maxAttempts = 20;
        const retryDelay = 250;
        const hasCookieControl = !!Cookies.get('CookieControl');
        const isSitecoreContext = this.isSitecoreContext();

        if (hasCookieControl || attempt >= maxAttempts || isSitecoreContext) {
            this.state = {
                ...this.state,
                isOpen: this.getIsOpen(),
            };

            this.render();
            return;
        }

        this.cookieControlTimeout = setTimeout(() => {
            this.initModal(attempt + 1);
        }, retryDelay);
    };

    getIsOpen = () => {
        const isSitecoreContext = this.isSitecoreContext();

        if (!Cookies.get('CookieControl') && !isSitecoreContext) {
            return false;
        }

        const areFieldsFilled = this.options && (
            this.options.image ||
            this.options.text ||
            (this.options.cta && this.options.cta.text && this.options.cta.url)
        );

        if (!areFieldsFilled) {
            return false;
        }

        if (isSitecoreContext) {
            return true;
        }

        const lastShown = sessionStorage.getItem('promotionModalLastShown');

        if (!lastShown) {
            sessionStorage.setItem('promotionModalLastShown', Date.now());
            return true;
        }

        if (this.options.popAgainInSession && this.options.minuteFrequency) {
            const isTimeElapsed = Date.now() - parseInt(lastShown, 10) > this.options.minuteFrequency * 60 * 1000;

            if (isTimeElapsed) {
                sessionStorage.setItem('promotionModalLastShown', Date.now());
                return true;
            }
        }

        return false;
    };

    destroy() {
        clearTimeout(this.cookieControlTimeout);
        reactDOM.unmountComponentAtNode(this.element);
    }

    hide = () => {
        this.state = {
            ...this.state,
            isOpen: false,
        };

        this.render();
    };

    render() {
        const isSitecoreContext = this.isSitecoreContext();

        if (!this.state.isOpen && !isSitecoreContext) {
            reactDOM.unmountComponentAtNode(this.element);
            return;
        }

        const modalOptions = {
            bemList: [bemClasses.WIDE, 'promotion-modal-dialog'],
        };

        const { image, text, cta } = this.options;

        const hasCta = cta && cta.text && cta.url && cta.theme;

        const content = (
            <div className={`promotion-modal ${!image ? 'promotion-modal--no-image' : ''}`}>
                {image && (
                    <div className="promotion-modal__media">
                        <img className="promotion-modal__image" src={image} alt="" />
                    </div>
                )}

                {(text || hasCta) && (
                    <div className="promotion-modal__content">
                        {text && (
                            <div
                                className="promotion-modal__text"
                                dangerouslySetInnerHTML={{ __html: text }}
                            />
                        )}

                        {hasCta && (
                            <div
                                className={`promotion-modal__cta button ${cta.theme ? `button--${cta.theme}` : ''}`}
                                onClick={() => redirectTo(cta.url)}
                            >
                                <span className="promotion-modal__cta-text">{cta.text}</span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );

        reactDOM.render(
            isSitecoreContext ? (
                <div className="promotion-modal-preview">
                    <div className="promotion-modal-preview__label">
                        Promotion Modal Preview
                    </div>
                    {content}
                </div>
            ) : (
                <ReactModal
                    options={modalOptions}
                    isOpen={this.state.isOpen}
                    onCloseCb={this.hide}
                >
                    {content}
                </ReactModal>
            ),
            this.element,
        );
    }
}

export default PromotionModalComponent;
